module.exports = __webpack_public_path__ + "static/poligono1_02-c294222990818e9348c9ea2f97c81245.jpg";